
@if(groupedInvoiceEditHistoryData && groupedInvoiceEditHistoryData.length > 0) {
    @for (item of groupedInvoiceEditHistoryData; track $index) {
        <div class="edit-history-content">
            <p-fieldset class="p-fieldset-class">
                <ng-template pTemplate="header">
                <div class="flex items-center gap-2 px-2">
                    <span style="font-size: 14px;">{{item.runDate}}</span>
                </div>
                </ng-template>
                <p-table 
                    [value]="item?.items"
                    dataKey="id"
                    [tableStyle]="{ 'min-width': '60rem' }">
                    <ng-template pTemplate="header">
                        <tr>
                            <th class="table-header-main">Code</th>
                            <th class="table-header-main">Description</th>
                            <th class="table-header-main">System Disposition</th>
                            <th class="table-header-main">Comments</th>
                            <th class="table-header-main">Reason</th>
                            <th class="table-header-main">Disposition</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-i>
                        <tr style="font-size: 12px;">
                            <td>{{i.code}}</td>
                            <td>{{i.desc}}</td>
                            <td>{{i.systemDisposition}}</td>
                            <td>{{i.comments}}</td>
                            <td>{{i.reason}}</td>
                            <td>{{i.disposition}}</td>
                        </tr>
                    </ng-template>
                </p-table>
            </p-fieldset>
        </div>
        
    } 
} @else {
    <div>No records found</div>
}
